import { Reveal, Eyebrow } from "../components/Reveal";
import { EnquiryForm } from "../components/EnquiryForm";
import { SITE } from "../siteConfig";

export default function Contact() {
  return (
    <>
      <section data-testid="contact-hero" className="bg-forest pb-20 pt-40 text-limestone md:pb-24 md:pt-52">
        <div className="mx-auto max-w-6xl px-5 md:px-8">
          <Reveal><Eyebrow light>Contact</Eyebrow></Reveal>
          <Reveal delay={0.1}>
            <h1 className="mt-5 max-w-3xl font-serif text-4xl leading-[1.08] tracking-tight sm:text-5xl lg:text-6xl">
              Tell us about your project.
            </h1>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-6 max-w-xl text-base leading-relaxed text-limestone/80 md:text-lg">
              A few details will help us understand what you need. You don't need to know the technical
              terminology — we can work through that together.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="mx-auto max-w-6xl px-5 py-20 md:px-8 md:py-28">
        <div className="grid gap-14 lg:grid-cols-5">
          <Reveal className="lg:col-span-3">
            <EnquiryForm />
          </Reveal>
          <div className="lg:col-span-2">
            <Reveal delay={0.1} className="border border-forest/15 bg-limestone-dark/50 p-8">
              <h2 className="font-serif text-xl text-forest">Where we work</h2>
              <p className="mt-3 text-sm leading-relaxed text-charcoal/80" data-testid="contact-service-area">
                {SITE.base}, covering the {SITE.areas.slice(0, -1).join(", ")} and{" "}
                {SITE.areas[SITE.areas.length - 1]}. If you're a little further afield, ask anyway — we'll be
                honest about what's practical.
              </p>
              <h2 className="mt-8 font-serif text-xl text-forest">What happens next</h2>
              <ol className="mt-4 space-y-4">
                {[
                  "We read your enquiry and come back with any initial questions.",
                  "If it sounds workable, we arrange a short call to understand the land and the outcome you need.",
                  "You receive a clear scope and quotation before any commitment.",
                ].map((s, i) => (
                  <li key={s} className="flex items-start gap-4 text-sm leading-relaxed text-charcoal/80">
                    <span className="font-serif text-xl italic text-ochre">{i + 1}.</span>
                    {s}
                  </li>
                ))}
              </ol>
              <div className="mt-8 border-t border-forest/15 pt-6 text-sm leading-relaxed text-charcoal/70" data-testid="contact-direct-details">
                {SITE.email ? (
                  <p>
                    Prefer email? Write to{" "}
                    <a href={`mailto:${SITE.email}`} data-testid="contact-email-link" className="link-underline font-medium text-forest">
                      {SITE.email}
                    </a>
                  </p>
                ) : (
                  <p>
                    Our direct email address will be published here shortly. For now, the enquiry form is the
                    fastest way to reach us.
                  </p>
                )}
              </div>
            </Reveal>
          </div>
        </div>
      </section>
    </>
  );
}
